export enum EReservationPaymentStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  OVERPAID = 'OVERPAID',
  PARTIAL_PAID = 'PARTIAL_PAID',
  UNKNOWN = 'UNKNOWN',
}
